<template>
    <b-container fluid class="mt--7">
        <b-card title="Task Types">
            <b-card-body>
                <b-form>
                    <b-form-group
                        id="fieldset-isTaskType "
                        label="Task Types"
                        label-for="input-isTaskType "
                        label-cols="2"
                    >
                        <b-form-checkbox
                            id="input-isTaskType "
                            v-model="isTaskType"
                        >
                        </b-form-checkbox>
                    </b-form-group>

                    <b-form-group
                        id="fieldset-measureable"
                        label="Measureable Item Types"
                        label-for="input-measureable"
                        label-cols="2"
                        v-if="isTaskType"
                    >
                        <multiselect
                            id="input-measureable"
                            v-model="measurableTypesOptions"
                            :multiple="true"
                            :options="items"
                            label="name"
                            track-by="id"
                            :close-on-select="false"
                        >
                        </multiselect>
                    </b-form-group>

                    <b-form-group
                        id="fieldset-checkable"
                        label="Checkable Item Types"
                        label-for="input-checkable"
                        label-cols="2"
                        v-if="isTaskType"
                    >
                        <multiselect
                            id="input-checkable"
                            v-model="checkableTypesOptions"
                            :multiple="true"
                            :options="items"
                            label="name"
                            track-by="id"
                            :close-on-select="false"
                        >
                        </multiselect>
                    </b-form-group>

                    <b-form-group
                        id="fieldset-productCaption"
                        label="Product Caption"
                        label-for="input-productCaption"
                        label-cols="2"
                        v-if="isTaskType"
                    >
                        <b-form-input
                            id="input-productCaption"
                            v-model="formData.productCaption"
                        >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="fieldset-measurableCaption"
                        label="Measureable Caption"
                        label-for="input-measurableCaption"
                        label-cols="2"
                        v-if="isTaskType"
                    >
                        <b-form-input
                            id="input-measurableCaption"
                            v-model="formData.measurableCaption"
                        >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="fieldset-checkableCaption"
                        label="Checkable Caption"
                        label-for="input-checkableCaption"
                        label-cols="2"
                        v-if="isTaskType"
                    >
                        <b-form-input
                            id="input-checkableCaption"
                            v-model="formData.checkableCaption"
                        >
                        </b-form-input>
                    </b-form-group>

                    <b-button variant="primary" @click="updateTypes" size="sm">
                        <b-spinner
                            small
                            v-if="updating"
                            label="Loading..."
                        ></b-spinner>
                        <span v-else>Update</span>
                    </b-button>
                </b-form>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import Multiselect from 'vue-multiselect'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'taskTypeValue',
    mixins: [popupMixins, permissionsMixins],
    components: { Multiselect },
    data: () => ({
        componentName:'Task Type',
        formData: {
            isTaskType: 0,
            measurableTypes: [],
            checkableTypes: [],
            productCaption: null,
            measurableCaption: null,
            checkableCaption: null,
        },
        updating: false,
    }),

    filters: {
        filterOptions(items) {
            return items.map(({ id: value, name: text }) => ({ value, text }))
        },
    },

    computed: {
        //checkableTypes
        isTaskType: {
            get() {
                return !!this.formData.isTaskType
            },
            set(value) {
                this.$set(this.formData, 'isTaskType', value ? 1 : 0)
            },
        },

        checkableTypesOptions: {
            get() {
                const {
                    items,
                    formData: { checkableTypes },
                } = this
                return checkableTypes.map(id =>
                    items.find(item => item.id == id)
                )
            },
            set(selectedItems) {
                this.$set(
                    this.formData,
                    'checkableTypes',
                    selectedItems.map(x => x.id)
                )
            },
        },

        measurableTypesOptions: {
            get() {
                const {
                    items,
                    formData: { measurableTypes },
                } = this
                return measurableTypes.map(id =>
                    items.find(item => item.id == id)
                )
            },
            set(selectedItems) {
                this.$set(
                    this.formData,
                    'measurableTypes',
                    selectedItems.map(x => x.id)
                )
            },
        },

        taskTypeValue() {
            const taskTypeValue = this.$store.getters['company/taskTypeValue']
            console.log('computed taskTypeValue', taskTypeValue)
            return taskTypeValue
        },

        taskTypeKey() {
            return this.$store.state.company.settingKeys.taskTypeKey
        },

        items() {
            const items = this.$store.state.itemType.items
            console.log('items', items)
            return items
                .filter(x => x.is_task)
                .map(x => {
                    x.is_task = !!x.is_task
                    x.is_order_item = !!x.is_order_item
                    x.is_discount = !!x.is_discount
                    return x
                })
        },
    },

    watch: {
        taskTypeValue: {
            handler: function (val) {
                console.log('watch taskTypeValue', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },

    created() {
        this.$store.dispatch('itemType/fetchAll')
    },

    async mounted() {
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.taskTypeKey
        )
        this.$nextTick(() => {
            this.updateModel(this.taskTypeValue)
        })
    },

    methods: {
        updateModel(taskTypeValue) {
            const value = { ...(taskTypeValue || {}) }
            this.$set(this.formData, 'isTaskType', value.isTaskType || 0)
            this.$set(
                this.formData,
                'measurableTypes',
                value.measurableTypes || []
            )
            this.$set(
                this.formData,
                'checkableTypes',
                value.checkableTypes || []
            )
            this.$set(
                this.formData,
                'productCaption',
                value.productCaption || null
            )
            this.$set(
                this.formData,
                'measurableCaption',
                value.measurableCaption || null
            )
            this.$set(
                this.formData,
                'checkableCaption',
                value.checkableCaption || null
            )
        },
        async updateTypes() {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.formData)
                const bool_value = false

                await this.$store.dispatch('company/updateConfiguration', {
                    key: this.taskTypeKey,
                    text_value,
                    bool_value,
                })
                
                this.genericToast(this.componentName,'Updated','success',`${this.componentName} successfully updated`)
                //this.doToast('Success!', 'Settings Updated', 'success')


            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
